import { Frown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { BoxIcon } from '@/Domain/components/Shared/BoxIcon/BoxIcon';
import { TableCell, TableRow } from '@/Domain/components/Shared/Table/Table';

export const EmptyTableRow = () => {
  const { t } = useTranslation('insights_page', { keyPrefix: 'chart_placeholders' });

  return (
    <TableRow className="hover:!bg-transparent mx-auto border-b-0">
      <TableCell colSpan={4} className="text-center space-y-2 py-12 text-sm text-foreground-subtle">
        <BoxIcon variant="outlined" className="mx-auto">
          <Frown className="text-foreground-subtle size-4" />
        </BoxIcon>
        <p className="font-semibold">{t('no_data_in_range.title')}</p>
        <p className="text-xs text-foreground-subtle">{t('no_data_in_range.description')}</p>
      </TableCell>
    </TableRow>
  );
};
